import { HTMLTable } from '@blueprintjs/core';
import { ReactNode } from 'react';
import Pagination from '../../views/users/components/pagination/pagination';
import {
  TableContainer,
  PaginationContainer,
  LinesPerPage,
  SelectLinesPerPage,
  DivLinesPerPage,
} from '../TableItems/styles';

export interface Column<T> {
  title: string;
  render: (record: T) => ReactNode;
}

interface PaginationConfig {
  totalPages: number;
  currentPage: number;
  onPageChange: (pageNumber: number) => void;
}

interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  rowKey: keyof T;
  pagination?: PaginationConfig;
  bordered?: boolean;
  compact?: boolean;
  interactive?: boolean;
  striped?: boolean;
  itemsPerPageOptions?: number[];
  itemsPerPage: number;
  onItemsPerPageChange: (value: number) => void;
}

const Table = <T extends object>({
  columns,
  data,
  rowKey,
  bordered,
  compact,
  interactive,
  striped,
  pagination,
  itemsPerPageOptions,
  itemsPerPage,
  onItemsPerPageChange,
}: TableProps<T>) => {
  return (
    <TableContainer>
      <HTMLTable
        bordered={bordered}
        compact={compact}
        interactive={interactive}
        striped={striped}
      >
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index}>{column.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={String(item[rowKey])}>
              {columns.map((column, index) => (
                <td key={index}>{column.render(item)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </HTMLTable>
      <PaginationContainer>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {pagination && (
            <Pagination
              currentPage={pagination.currentPage}
              onPageChange={pagination.onPageChange}
              totalPages={pagination.totalPages}
            />
          )}
          <DivLinesPerPage>
            <LinesPerPage> Linhas por página: </LinesPerPage>
            <SelectLinesPerPage
              value={itemsPerPage}
              onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
            >
              {itemsPerPageOptions &&
                itemsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
            </SelectLinesPerPage>
          </DivLinesPerPage>
        </div>
      </PaginationContainer>
    </TableContainer>
  );
};

export default Table;
